<template>
  <ProgressDrawer
    :is-minimized="isMinimized"
    :button-icon="buttonIcon"
    @next="next"
  >
    <template v-if="hasMessage" #message>
      <AnswerMessage :answer="answer" :question="question" />
    </template>
  </ProgressDrawer>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import ProgressDrawer from '@/components/progress/ProgressDrawer'
import AnswerMessage from '@/components/messages/AnswerMessage'

export default {

  components: {
    ProgressDrawer,
    AnswerMessage
  },

  props: {
    answer: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    },
    buttonIcon: {
      type: String,
      default: null
    }
  },

  computed: {

    isMinimized () {
      return this.question.autoprogress || this.question.inlineNextButton || !this.hasAnswer
    },

    hasMessage () {
      return this.hasAnswer && Boolean(this.question.message)
    },

    hasAnswer () {
      const hasResult = this.answer && this.answer.result

      if (!hasResult) return false

      const { result } = this.answer

      return !isEmpty(result)
    }
  },

  methods: {
    next () {
      this.$emit('next')
    }
  }
}
</script>
